import React from 'react';
import PropTypes from 'prop-types';
import { Field } from '@cordata/buffet';
import { Row, Col } from 'reactstrap';
import { useFormikContext } from 'formik';

import { store } from '~/utils/care-giver';

const Fields = ({ disabled }) => {
  const { values } = useFormikContext();

  return (
    <>
      <fieldset disabled={disabled}>
        <Row form>
          <Col sm>
            <Field
              name="firstName"
              required
            />
          </Col>

          <Col sm>
            <Field
              name="lastName"
              required
            />
          </Col>

          <Col sm>
            <Field
              name="relationship"
              type="select"
              options={store.support.relationships}
              required
              disabled={disabled}
            />
          </Col>
        </Row>
      </fieldset>

      <fieldset disabled={disabled}>
        <Row form>
          <Col sm>
            <Field
              name="preferredPhoneType"
              type="radio-group"
              options={store.support.phoneTypes}
              inline
              required
              disabled={disabled}
            />
          </Col>

          <Col sm>
            <Field
              name="homePhone"
              type="tel"
            />
          </Col>

          <Col sm>
            <Field
              name="mobilePhone"
              type="tel"
            />
          </Col>
        </Row>
      </fieldset>

      <fieldset disabled={disabled}>
        <Row form>
          <Col sm>
            <Field
              name="email"
              type="email"
            />
          </Col>

          <Col sm>
            <Field
              name="isPrimary"
              type="checkbox"
            />
          </Col>

          <Col sm>
            <Field
              name="isCurrent"
              type="checkbox"
            />
          </Col>
        </Row>

        <Field
          name="roles"
          type="checkbox-group"
          options={store.support.roles}
          columns={3}
          disabled={disabled}
        />

        {values.roles?.includes('Other') &&
          <Field
            name="otherRoles"
            text="comma separated"
          />
        }

        {values.roles?.includes('Interpreter') && (
          <Row form>
            <Col sm>
              <Field
                name="interpreterId"
              />
            </Col>

            <Col sm>
              <Field
                name="interpreterLanguage"
              />
            </Col>
          </Row>
        )}
      </fieldset>

      <fieldset disabled={disabled}>
        <Field
          name="comment"
          type="textarea"
        />
      </fieldset>
    </>
  );
};

Fields.propTypes = {
  disabled: PropTypes.bool,
};

Fields.defaultProps = {
  disabled: false,
};

export default Fields;
